/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/global.type';
import * as actions from 'src/types/appconfig-action.type';

export type AppConfigState = {
  rolesCustomlimits: Array<any>,
  isSettingLimits: boolean,
};

const initialState = {
  rolesCustomlimits: [],
  isSettingLimits: false,
}

export const appConfigReducer = (
  state: AppConfigState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.GET_CUSTOM_ROLES_LIMIT_BY_APP:
      return {
        ...state,
        isSettingLimits: true,
      };
    case actions.GET_CUSTOM_ROLES_LIMIT_BY_APP_SUCCESS:
      let baseList = JSON.parse(JSON.stringify(state.rolesCustomlimits));
      let currentConfigIndex = baseList.findIndex((el:any, i:number) => el.serviceId === action.payload.serviceId)
      if (currentConfigIndex !== -1) {
        baseList[currentConfigIndex].limit = action.payload.limit;
      } else {
        baseList.push({
            serviceId: action.payload.serviceId,
            limit: action.payload.limit,
        })
      }
      return {
        ...state,
        rolesCustomlimits: baseList,
        isSettingLimits: false,
      };
    case actions.GET_CUSTOM_ROLES_LIMIT_BY_APP_FAILURE:
      return {
        ...state,
        isSettingLimits: false,
      };
    default:
      return state
  }
}
